import { render, staticRenderFns } from "./ParametersList.vue?vue&type=template&id=9b576e0e&scoped=true"
import script from "./ParametersList.vue?vue&type=script&lang=js"
export * from "./ParametersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b576e0e",
  null
  
)

export default component.exports